import { makeStyles } from '@material-ui/core/styles';
import Theme from '../../theme/booking-theme';

const useStyles = makeStyles({
  rootPageSection: {
    paddingTop: '60px',
    [Theme.breakpoints.down('lg')]: {
      paddingTop: '40px',
    },
    [Theme.breakpoints.down('sm')]: {
      paddingTop: '30px',
    },
  },
});

export default useStyles;
